var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tl-item"},[_vm._m(0),_c('div',{staticClass:"tlx-txt"},[_vm._t("title"),_vm._t("content")],2)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tlx-divider"},[_c('div',{staticClass:"tlx-point"}),_c('div',{staticClass:"tlx-line"})])
}]

export { render, staticRenderFns }